import React  from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import './App.css';
import './Notebook.css';
import './NotebookEditPopup.css';
import NotebookLang from './NotebookLang.json';

class NotebookEditPopup extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			notebookID: 0,
			notebookJsonObj: null,
			title: "",
		}
	}
		
	async componentDidMount() {
	}

	async componentDidUpdate() {

		var notebookID1 = this.state.notebookID;
		var notebookID2 = this.props.notebookID;
		
		if (notebookID2 === 0) {
			return;
		}

		if (notebookID1 === notebookID2) {
			return;
		}

		var notebookJsonObj = await this.props.serverGetNotebookData(notebookID2);
		var title = notebookJsonObj.title;
		this.setState({
			notebookJsonObj: notebookJsonObj,
			title: title,
			notebookID: notebookID2,
		});
	}

	onKeyDown(keyCode) {
		if (keyCode === 13) {
			this.onClickSaveButton();
		}
	}
	
	onPopUpClosed() {
		this.props.setNotebookEditPopupYN(false);
	}

	onTitleChanged(value) {
		this.setState({title: value});
	}
	
	async serverSetNotebookTitle(notebookID, title) {
		
		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/setnotebooktitle?notebookid=" + notebookID;
		url = url + "&title=" + encodeURIComponent(title);
		
		var responseText = "";
		
		try {
			var res = await fetch(url);
			responseText = await res.text();
		} catch (err) {
		}

		return responseText;
	}

	async onClickSaveButton() {
		
		var title = this.state.title;
		title = title.trim();
		if (title === "") {
			this.props.showToast(this.props.getLang(NotebookLang, "titleIsEmpty"));
			return;
		}
		
		var notebookID = this.props.notebookID;

		await this.serverSetNotebookTitle(notebookID, title);

		var toastString = this.props.getLang(NotebookLang, "notebookTitleSaved");
		this.props.showToast(toastString);
		this.onPopUpClosed();
		this.props.refreshData();
	}
	
	onClickCancelButton() {
		this.onPopUpClosed();
	}
	
	renderContent() {

		var title = this.state.title;
		
		return (
			<div className="NotebookEditPopupTopContainer">
				<div style={{height: "10px"}}></div>
				<div className="NotebookEditPopupTitle">{this.props.getLang(NotebookLang, "editTitle")}</div>
				<hr className="NotebookCustomLine" />
				<div style={{height: "20px"}}></div>
				<div className="ViewContainer2">
					<fieldset className="NotebookEditPopupFieldset">
						<legend className="NotebookEditPopupLegend">{this.props.getLang(NotebookLang, "notebookTitle")}</legend> 
						<input
							className="NotebookEditPopupInput" 
							autoFocus={true}
							id="title" 
							type="text" 
							value={title}
							onChange={(event) => this.onTitleChanged(event.target.value)}
							onKeyDown={(event) => this.onKeyDown(event.keyCode)}
						/>
					</fieldset>
				</div>
				<div style={{height: "30px"}}></div>
				<div className="ViewContainerButtons2">
					<button className="ViewCancelButton" onClick={() => this.onClickCancelButton()}>{this.props.getLang(NotebookLang, "cancel")}</button>
					<div style={{width: "20px"}}></div>
					<button className="ViewSaveButton" onClick={() => this.onClickSaveButton()}>{this.props.getLang(NotebookLang, "save")}</button>
				</div>
				<div style={{height: "20px"}}></div>				
			</div>
		);
	}
	
	render() {
		
		var renderPopupYN = this.props.renderPopupYN;
		
		if (!renderPopupYN) {
			return null;
		}

		return (
			<Popup
				className="notebook-edit-popup"
				open={true}
				closeOnEscape
				closeOnDocumentClick
				onClose={() => this.onPopUpClosed()}
			>
				{this.renderContent()}
			</Popup>
		);
	}
}

export default NotebookEditPopup;